import Icon from '../../../components/AppIcon';
import type { SocialLink } from '../types';

interface SocialLinksProps {
  links: SocialLink[];
}

const SocialLinks = ({ links }: SocialLinksProps) => {
  return (
    <div className="flex items-center justify-center gap-4">
      {links.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.ariaLabel}
          className="w-10 h-10 rounded-lg bg-surface hover:bg-accent/20 flex items-center justify-center transition-all duration-300 hover:scale-110 group"
        >
          <Icon
            name={social.icon}
            size={20}
            className="text-secondary group-hover:text-accent transition-colors"
          />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;